import { DomainError } from "./errors";

/** Divisão inteira com arredondamento comercial (meio para longe do zero). `den` > 0. */
function roundDiv(num: bigint, den: bigint): bigint {
  const q = num / den; // trunca em direção ao zero
  const r = num % den;
  const twice = 2n * (r < 0n ? -r : r);
  if (twice >= den) return num < 0n ? q - 1n : q + 1n;
  return q;
}

/** BigInt → number; fora de ±2^53 lança DomainError(`code`). */
export function toSafe(v: bigint, code: string): number {
  const n = Number(v);
  if (!Number.isSafeInteger(n)) throw new DomainError(code, `valor fora do limite: ${v}`);
  return n;
}

function assertInt(v: number, what: string): void {
  if (!Number.isSafeInteger(v)) throw new DomainError("not_integer", `${what} deve ser inteiro: ${v}`);
}

/** preço (centavos) × quantidade (q4) → centavos. Conta em BigInt: exata mesmo acima de 2^53. */
export function mulQ4(priceCents: number, qtyQ4: number): number {
  assertInt(priceCents, "preço");
  assertInt(qtyQ4, "quantidade");
  return toSafe(roundDiv(BigInt(priceCents) * BigInt(qtyQ4), 10_000n), "invalid_money");
}

/** valor (centavos) × percentual (pct4) → centavos. 12,5% = 125000; 100% = 1000000. */
export function applyPct(valueCents: number, pct4: number): number {
  assertInt(valueCents, "valor");
  assertInt(pct4, "percentual");
  return toSafe(roundDiv(BigInt(valueCents) * BigInt(pct4), 1_000_000n), "invalid_money");
}
